<template>
    <div class="nfse">
        <PageTitle main="NFS-e" sub="" />
        
        <div id="pageGrid" v-show="!modalActive">
            <div id="barraBotoes">
                <b-row>
                    <b-col cols="10" class="text-left">
                        <b-button id="btn-principal" variant="success" 
                            @click="addNfse()" size="lgx" class="mb-2 mr-2" v-if="user.nfse_adi">  
                            <i class="fa fa-plus"></i> Adicionar
                        </b-button>
                        <b-button id="btn-pesquisa" variant="secondary" 
                            @click="togglePesquisa()" size="lgx" class="mb-2 mr-2">  
                            <i class="fa fa-search"></i> Pesquisar
                        </b-button>
                        <b-button id="btn-relatorio" variant="secondary" 
                            @click="toggleRelatorio()" size="lgx" class="mb-2 mr-2">  
                            <i class="fa fa-print"></i> Relatório
                        </b-button>
                        <b-button id="btn-exportacao" variant="secondary" 
                            @click="toggleExportacao()" size="lgx" class="mb-2 mr-2">  
                            <i class="fa fa-download"></i> Exportação
                        </b-button>
                    </b-col>
                </b-row>
            </div>   
            <b-table :items="nfses" :fields="fields"
                responsive 
                striped
                borderless>      
                <template slot="nm_empresa" slot-scope="data">
                    <span style="font-weight: 500;">{{ data.item.nm_empresa }}</span> <br>
                    <span style="font-size: smaller;">{{ data.item.cnpj_empresa }}</span>
                </template>
                <template slot="nm_cliente" slot-scope="data">
                    <span style="font-weight: 500;">{{ data.item.nm_cliente }}</span> <br>
                    <span style="font-size: smaller;">{{ data.item.vlr_total }} - {{ data.item.dt_competencia }}</span>
                </template>          
                <template slot="situacoes" slot-scope="data">
                    <b-badge style="padding:6px 0px 6px 0px; width: 150px;" 
                            :class="((data.item.fl_situacao === '1') || (data.item.fl_situacao === '2') || 
                                    (data.item.fl_situacao === '3')) ? 'help mr-2' : 'mr-2'"
                            :title="((data.item.fl_situacao === '1') || (data.item.fl_situacao === '2') || 
                                    (data.item.fl_situacao === '3')) ? data.item.msg_erro : ''"
                            :variant="getStatusItem(data.item.fl_situacao)">
                        {{data.item.status}}
                    </b-badge>
                </template>
                <template slot="actions" slot-scope="data">
                    <b-button variant="primary" title="Editar NFS-e"
                        @click="loadNfse(data.item)" size="sm mr-2">  
                        <i class="fa fa-pencil"></i>
                    </b-button>
                    <b-dropdown>
                        <b-dropdown-item :disabled="((data.item.fl_situacao !== '0') || (data.item.integracao_id === null))" @click="removeNfse(data.item)" v-if="user.nfse_exc">Excluir NFS-e</b-dropdown-item>
                        <b-dropdown-item @click="cloneNfse(data.item)" v-if="user.nfse_adi">Clonar NFS-e</b-dropdown-item>
                        <b-dropdown-item :disabled="((data.item.fl_situacao === '0') || (data.item.fl_situacao === '1') || (data.item.fl_situacao === '2') || (data.item.fl_situacao === '3') || (data.item.fl_situacao === 'C') || (data.item.fl_situacao === 'P') ||  (data.item.fl_situacao === 'X'))" @click="cancelNfse(data.item)" v-if="user.nfse_edi">Cancelar NFS-e</b-dropdown-item>
                        <b-dropdown-item :disabled="((data.item.fl_situacao === '0') || (data.item.fl_situacao === '1') || (data.item.fl_situacao === '2') || (data.item.fl_situacao === '3') || (data.item.fl_situacao === 'P') || (data.item.fl_situacao === 'X'))" @click="openPdfNfse(data.item)" v-if="user.nfse_dow">Abrir PDF da NFS-e</b-dropdown-item>
                        <b-dropdown-item :disabled="((data.item.fl_situacao === '0') || (data.item.fl_situacao === '1') || (data.item.fl_situacao === '2') || (data.item.fl_situacao === '3') || (data.item.fl_situacao === 'P') || (data.item.fl_situacao === 'X'))" @click="downloadPdfNfse(data.item)" v-if="user.nfse_dow">Download PDF da NFS-e</b-dropdown-item>
                        <b-dropdown-item :disabled="((data.item.fl_situacao === '0') || (data.item.fl_situacao === '1') || (data.item.fl_situacao === '2') || (data.item.fl_situacao === '3') || (data.item.fl_situacao === 'P') || (data.item.fl_situacao === 'X'))" @click="downloadXmlNfse(data.item)" v-if="user.nfse_dow">Download XML da NFS-e</b-dropdown-item>
                        <b-dropdown-item :disabled="((data.item.fl_situacao === '0') || (data.item.fl_situacao === '1') || (data.item.fl_situacao === '2') || (data.item.fl_situacao === '3') || (data.item.fl_situacao === 'P') || (data.item.fl_situacao === 'X'))" @click="sendEmailNfse(data.item)" v-if="user.nfse_ema">Enviar NFS-e por E-mail</b-dropdown-item>
                    </b-dropdown>
                </template>
            </b-table>

            <b-pagination class="customPagination mt-4" size="md" v-model.trim="page" :total-rows="count" :per-page="limit" />
        </div>
        
        <b-modal ref="modalPesquisa" hide-footer no-close-on-esc no-close-on-backdrop centered title="Pesquisa NFS-e" size="xl">
            <template v-slot:modal-footer="{ pesquisarNotas, limparFiltros }">
                <div class="p-4">
                    <b-row>
                        <b-col md="3" sm="12">
                            <b-form-group label="Situação" label-for="filtro-situacaoSelecionada">
                                <b-form-select 
                                    id="situacaoSelecionada"
                                    name="situacaoSelecionada"
                                    ref="situacaoSelecionada"
                                    v-model.trim="situacaoSelecionada" 
                                    :options="optSituacao">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
    
                        <b-col md="3" sm="12" >
                            <b-form-group label="Competência Inicial" label-for="filtro-dt_inicial">
                                <b-form-input 
                                    type="text"
                                    id="filtro-dt_inicial" 
                                    name="filtro-dt_inicial" 
                                    ref="filtro-dt_inicial"
                                    v-model.trim="filtro.dt_inicial" 
                                    v-mask="'##/##/####'"
                                    placeholder="dd/mm/aaaa">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
    
                        <b-col md="3" sm="12">
                            <b-form-group label="Competência Final" label-for="filtro-dt_final">
                                <b-form-input 
                                    type="text"
                                    id="filtro-dt_final" 
                                    name="filtro-dt_final" 
                                    ref="filtro-dt_final"
                                    v-model.trim="filtro.dt_final" 
                                    v-mask="'##/##/####'"
                                    placeholder="dd/mm/aaaa">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
    
                        <b-col md="3" sm="12">
                            <b-form-group label="Número" label-for="filtro-numero">
                                <b-form-input 
                                    type="text"
                                    id="filtro-numero" 
                                    name="filtro-numero" 
                                    ref="filtro-numero" 
                                    v-model.trim="filtro.numero" 
                                    maxlength="50" 
                                    placeholder="Nr. NFSe">
                                </b-form-input>
                            </b-form-group>
                        </b-col> 
                    </b-row>
    
                    <b-row>
                        <b-col md="2" sm="12">
                            <b-form-group label="Valor" label-for="filtro-valor">
                                    <input 
                                    type="text" 
                                    id="filtro-valor" 
                                    name="filtro-valor" 
                                    ref="filtro-valor" 
                                    style="text-align: right;"
                                    class="form-control" 
                                    v-money="money" /> 
                            </b-form-group>
                        </b-col>
    
                        <b-col md="3" sm="12">
                            <b-form-group label="CNPJ/CPF" label-for="filtro-cnpj_cpf">
                                <b-form-input 
                                    type="text"
                                    id="filtro-cnpj_cpf" 
                                    name="filtro-cnpj_cpf" 
                                    ref="filtro-cnpj_cpf" 
                                    v-model.trim="filtro.cnpj_cpf" 
                                    maxlength="14" 
                                    placeholder="CNPJ/CPF">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
    
                        <b-col md="7" sm="12">
                            <b-form-group label="Cliente" label-for="filtro-nome_cliente">
                                <b-form-input 
                                    type="text"
                                    id="filtro-nome_cliente" 
                                    name="filtro-nome_cliente" 
                                    ref="filtro-nome_cliente" 
                                    v-model.trim="filtro.nome_cliente" 
                                    maxlength="100" 
                                    placeholder="Nome Cliente">
                                </b-form-input>
                            </b-form-group>
                        </b-col>                        
                    </b-row>
    
                    <b-row>
                        <b-col md="6" sm="12">
                            <b-form-group label="Email" label-for="filtro-email">
                                <b-form-input 
                                    type="text"
                                    id="filtro-email" 
                                    name="filtro-email" 
                                    ref="filtro-email" 
                                    v-model.trim="filtro.email" 
                                    maxlength="50" 
                                    placeholder="E-mail">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
    
                        <b-col md="3" sm="12">
                            <b-form-group label="ID Externo" label-for="filtro-id_externo">
                                <b-form-input 
                                    type="text"
                                    id="filtro-id_externo" 
                                    name="filtro-id_externo" 
                                    ref="filtro-id_externo" 
                                    v-model.trim="filtro.id_externo" 
                                    maxlength="50" 
                                    placeholder="ID Externo">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
    
                        <b-col md="3" sm="12">
                            <b-form-group label="ID" label-for="filtro-id_interno">
                                <b-form-input 
                                    type="text"
                                    id="filtro-id_interno" 
                                    name="filtro-id_interno" 
                                    ref="filtro-id_interno" 
                                    v-model.trim="filtro.id_interno" 
                                    maxlength="10" 
                                    placeholder="ID Interno API">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>  
    
                    <b-row>
                        <b-col md="12" sm="12">
                            <b-form-group label="Empresa" label-for="filtro-empSelecionada">
                                <b-form-select 
                                    id="empSelecionada"
                                    name="empSelecionada"
                                    ref="empSelecionada"
                                    v-model.trim="empSelecionada" 
                                    :options="companies"> 
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                    </b-row>  
                </div>

                <div class="pr-3 pb-3" style="display: flex; justify-content: end;">
                    <b-button variant="secondary" class="mr-2" style="width: 200px;"
                        @click="limparFiltros()">Limpar Filtros 
                    </b-button>
                    <b-button id="btn-principal" variant="secondary" class="mr-2" style="width: 200px;"
                        @click="pesquisarNotas()"><i class="fa fa-search"></i> Pesquisar 
                    </b-button>
                </div>                     
            </template>
        </b-modal>  

        <b-modal ref="modalRelatorio" hide-footer hide-header-close no-close-on-esc no-close-on-backdrop centered title="Relatório de NFS-e em CSV" size="xl">
            <template v-slot:modal-footer="{ gerarRelatorio, limparFiltrosRelatorio }">
                <div class="p-4"> 
                    <b-row>
                        <b-col md="6" sm="12">
                            <b-form-group label="*Empresa" label-for="filtro-empRepSelecionada">
                                <b-form-select 
                                    id="empRepSelecionada"
                                    name="empRepSelecionada"
                                    ref="empRepSelecionada"
                                    v-model.trim="empRepSelecionada" 
                                    :options="companies"> 
                                </b-form-select>     
                            </b-form-group>
                        </b-col>

                        <b-col md="3" sm="12" >
                            <b-form-group label="*Competência Inicial" label-for="filtro-rep-dt_inicial">
                                <b-form-input 
                                    type="text"
                                    id="filtro-rep-dt_inicial"    
                                    name="filtro-rep-dt_inicial" 
                                    ref="filtro-rep-dt_inicial"
                                    v-model.trim="filtroRep.dt_inicial" 
                                    v-mask="'##/##/####'"
                                    placeholder="dd/mm/aaaa">
                                </b-form-input>
                            </b-form-group>
                        </b-col>

                        <b-col md="3" sm="12">
                            <b-form-group label="*Competência Final" label-for="filtro-rep-dt_final">
                                <b-form-input 
                                    type="text"
                                    id="filtro-rep-dt_final" 
                                    name="filtro-rep-dt_final" 
                                    ref="filtro-rep-dt_final"
                                    v-model.trim="filtroRep.dt_final" 
                                    v-mask="'##/##/####'"
                                    placeholder="dd/mm/aaaa">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12" sm="12">
                            <b-form-group label="Atividade / CNAE" label-for="filtro-cnaeRepSelecionada">
                                <b-form-select 
                                    id="cnaeRepSelecionada"
                                    name="cnaeRepSelecionada"
                                    ref="cnaeRepSelecionada"
                                    v-model.trim="cnaeRepSelecionada" 
                                    :options="cnaesCache">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                    </b-row>

                </div> 

                <div class="pr-3 pb-3" style="display: flex; justify-content: end;">
                    <b-button variant="secondary" class="mr-2" style="width: 150px;"
                        @click="limparFiltrosRelatorio()"> Fechar
                    </b-button>
                    <b-button id="btn-principal" variant="secondary" class="mr-2" style="width: 200px;"
                        @click="gerarRelatorio()"><i class="fa fa-table"></i> Exportar 
                    </b-button>
                </div>              
            </template>
        </b-modal>  

        <b-modal ref="modalExportacao" hide-footer hide-header-close no-close-on-esc no-close-on-backdrop centered title="Exportar XML de NFS-e" size="xl">
            <template v-slot:modal-footer="{ gerarExportacao, limparFiltrosExportacao }">
                <div class="p-4"> 
                    <b-row>
                        <b-col md="8" sm="12">
                            <b-form-group label="*Empresa" label-for="filtro-empExpSelecionada">
                                <b-form-select 
                                    id="empExpSelecionada"
                                    name="empExpSelecionada"
                                    ref="empExpSelecionada"
                                    v-model.trim="empExpSelecionada" 
                                    :options="companies"> 
                                </b-form-select>     
                            </b-form-group>
                        </b-col>

                        <b-col md="2" sm="12">
                            <b-form-group label="*Mês" label-for="filtro-exp-mesSelecionado">
                                <b-form-select 
                                    id="mesSelecionado"
                                    name="mesSelecionado"
                                    ref="mesSelecionado"
                                    v-model.trim="mesSelecionado" 
                                    :options="optMes">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>

                        <b-col md="2" sm="12">
                            <b-form-group label="*Ano" label-for="filtro-exp-anoSelecionado">
                                <b-form-select 
                                    id="anoSelecionado"
                                    name="anoSelecionado"
                                    ref="anoSelecionado"
                                    v-model.trim="anoSelecionado" 
                                    :options="optAno">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                    </b-row>
  
                    <b-row>
                        <b-col md="12" sm="12">
                            <b-form-group label="*E-mail para notificar a exportação" label-for="filtro-exp-email">
                                <b-form-input 
                                    type="text"
                                    id="filtro-exp-email" 
                                    name="filtro-exp-email" 
                                    ref="filtro-exp-email" 
                                    v-model.trim="filtroExp.email" 
                                    maxlength="100" 
                                    placeholder="E-mail">
                                </b-form-input>
                            </b-form-group>
                        </b-col>                    
                    </b-row>

                </div> 

                <div class="pr-3 pb-3" style="display: flex; justify-content: end;">
                    <b-button variant="secondary" class="mr-2" style="width: 150px;"
                        @click="limparFiltrosExportacao()"> Fechar
                    </b-button>
                    <b-button id="btn-principal" variant="secondary" class="mr-2" style="width: 200px;"
                        @click="gerarExportacao()"><i class="fa fa-table"></i> Exportar 
                    </b-button>
                </div>              
            </template>
        </b-modal>          

        <b-modal ref="modalPreferencia" hide-footer hide-header-close no-close-on-esc no-close-on-backdrop centered title="Preferências" size="md">
            <template v-slot:modal-footer="{ salvarPreferencia, hidePreferencia }">
                <b-card header="Opções"> 
                    <b-row>
                        <b-col md="12" sm="12" >
                            <b-form-group label="Tamanho da página">
                                <b-form-radio-group
                                    v-model="paginarPreferencia"
                                    :options="optPaginar"
                                    class="mb-3"
                                    value-field="item"
                                    text-field="name"
                                    stacked>
                                </b-form-radio-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-card> 
                <b-row class="text-center" align-v="center" style="padding: 20px 0px 0px 0px;"> 
                    <b-col xs="12" class="mb-1">
                        <b-button variant="secondary" class="mr-2" style="width: 150px;"
                            @click="salvarPreferencia()">Salvar 
                        </b-button>
                        <b-button variant="secondary" class="mr-2" style="width: 150px;"
                            @click="hidePreferencia()">Cancelar 
                        </b-button>
                    </b-col>
                </b-row>
            </template>
        </b-modal>  

        <b-modal ref="modalCancel" hide-footer hide-header centered title="Confirmação!">
            <p class="my-4" style="text-align: center;">Deseja realmente cancelar esta NFS-e?</p>
            <template v-slot:modal-footer="{ hideCancel , confirmeCancel }">

                <b-row align-v="center">
                    <b-col md="12" sm="12">
                        <b-form-group label="*Código de Cancelamento" label-for="codCancelSelecionada">
                            <b-form-select 
                                id="codCancelSelecionada"
                                name="codCancelSelecionada"
                                ref="codCancelSelecionada"
                                v-model.trim="codCancelSelecionada" 
                                :options="optCodigoCancel">
                            </b-form-select>     
                        </b-form-group>
                    </b-col>
                </b-row>  

                <b-row align-v="center">
                    <b-col md="12" sm="12">
                        <b-form-group label="*Justificativa" label-for="justifCancelSelecionada">
                            <b-form-input 
                                type="text"
                                id="justifCancelSelecionada" 
                                name="justifCancelSelecionada" 
                                ref="justifCancelSelecionada" 
                                v-model.trim="justifCancelSelecionada" 
                                maxlength="250">
                            </b-form-input>
                        </b-form-group>
                    </b-col>                        
                </b-row>  

                <hr>
                <b-row class="text-center mb-4" align-v="center" style="padding: 20px 0px 0px 0px;"> 
                    <b-col xs="12" class="mb-1">
                        <b-button id="btn-principal" variant="success" class="mr-2" style="width: 100px;"
                            @click="confirmeCancel()">Sim 
                        </b-button>
                        <b-button class="mr-2" style="width: 100px;"
                            @click="hideCancel()">Não
                        </b-button>
                    </b-col>
                </b-row>
            </template>
        </b-modal>          

        <b-modal ref="modalClone" hide-footer hide-header centered title="Confirmação!">
            <p class="my-4" style="text-align: center;">Deseja realmente duplicatar esta NFS-e para lançamento manual sem integração?</p>
            <template v-slot:modal-footer="{ hideClone , confirmeClone }">
                <b-row class="text-center mb-4" align-v="center" style="padding: 20px 0px 0px 0px;"> 
                    <b-col xs="12" class="mb-1">
                        <b-button id="btn-principal" variant="success" class="mr-2" style="width: 100px;"
                            @click="confirmeClone()">Sim 
                        </b-button>
                        <b-button class="mr-2" style="width: 100px;"
                            @click="hideClone()">Não
                        </b-button>
                    </b-col>
                </b-row>
            </template>
        </b-modal>          

        <b-modal ref="modalEmail" hide-footer hide-header centered title="Confirmação!">
            <p class="my-4" style="text-align: center;">Deseja realmente agendar envio de e-mail manual para esta NFS-e?</p>
            <template v-slot:modal-footer="{ hideEmail , confirmeEmail }">
                <b-row class="text-center mb-4" align-v="center" style="padding: 20px 0px 0px 0px;"> 
                    <b-col xs="12" class="mb-1">
                        <b-button id="btn-principal" variant="success" class="mr-2" style="width: 100px;"
                            @click="confirmeEmail()">Sim 
                        </b-button>
                        <b-button class="mr-2" style="width: 100px;"
                            @click="hideEmail()">Não
                        </b-button>
                    </b-col>
                </b-row>
            </template>
        </b-modal>      
        
        <b-modal ref="modalRemove" hide-footer hide-header centered title="Confirmação!">
            <p class="my-4" style="text-align: center;">Deseja realmente excluir esta NFS-e manual?</p>
            <template v-slot:modal-footer="{ hideRemove , confirmeRemove }">
                <b-row class="text-center mb-4" align-v="center" style="padding: 20px 0px 0px 0px;"> 
                    <b-col xs="12" class="mb-1">
                        <b-button variant="danger" class="mr-2"
                            @click="confirmeRemove()">Excluir 
                        </b-button>
                        <b-button class="mr-2"
                            @click="hideRemove()">Cancelar
                        </b-button>
                    </b-col>
                </b-row>
            </template>
        </b-modal>          
        
        <b-modal ref="modalTransmit" hide-footer hide-header centered title="Confirmação!">
            <p class="my-4" style="text-align: center;">Deseja realmente enviar esta NFS-e para processamento?</p>
            <template v-slot:modal-footer="{ saveAndTransmitNfse, hidetransmit }">
                <b-row class="text-center mb-4" align-v="center" style="padding: 20px 0px 0px 0px;"> 
                    <b-col xs="12" class="mb-1">
                        <b-button id="btn-principal" variant="success" class="mr-2" style="width: 100px;"
                            @click="saveAndTransmitNfse()">Sim 
                        </b-button>
                        <b-button class="mr-2" style="width: 100px;"
                            @click="hidetransmit()">Não
                        </b-button>
                    </b-col>
                </b-row>
            </template>
        </b-modal>  

        <div id="pageEdition" v-show="modalActive">
            <b-card :header="tituloModal"> 
                <b-form @submit.prevent="submit">  
                    <input id="usuario_id" type="hidden" v-model.trim="this.$store.state.user.userid"> 
                    <input id="nfse-id" type="hidden" v-model.trim="nfse.nfse_id"> 

                    <!--  
                    <b-card header="Pesquisa de Clientes e Serviços já cadastrados - Opcional!"> 
                        <b-row>
                            <b-col md="10" sm="12">
                                <b-form-group label="Informe um cliente já cadastrado ou preencha os campos manualmente" label-for="nfse-empresa_id">
                                    <b-form-select 
                                        id="find-cliente"
                                        name="find-cliente"
                                        ref="find-cliente"
                                        v-model.trim="nfse.tomador_id" 
                                        :options="clients"
                                        value-field="item"
                                        text-field="name"
                                        v-focus
                                        :readonly= "(nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C')">
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col md="1" sm="12" style="padding: 31px 0px 0px 10px">
                                <b-button variant="primary" @click="onSelectedOptionChanged" size="mr-2" title="Selecionar Cliente...">  
                                    <i class="fa fa-arrow-down"></i>
                                </b-button>
                            </b-col> 
                        </b-row>
                        <b-row>
                            <b-col md="10" sm="12">
                                <b-form-group label="Informe um serviço já cadastrado ou preencha os campos manualmente" label-for="nfse-empresa_id">
                                    <b-form-select 
                                        id="find-servico"
                                        name="find-servico"
                                        ref="find-servico"
                                        v-model.trim="nfse.produto_id" 
                                        :options="services"
                                        value-field="item"
                                        text-field="name"
                                        :readonly= "(nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C')">
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col md="1" sm="12" style="padding: 31px 0px 0px 10px">
                                <b-button variant="primary" @click="onSelectedOptionChanged" size="mr-2" title="Selecionar Serviço...">  
                                    <i class="fa fa-arrow-down"></i>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-card> 
                    <br>                   
                    -->

                    <b-row v-if="((!isInsert) && (nfse.msg_erro !== null))" class="mb-4">
                        <b-col md="12" sm="12">
                            <b-card-group deck class="mb-4">
                                <b-card
                                    border-variant="danger"
                                    header="Atenção!"
                                    header-bg-variant="danger"
                                    header-text-variant="white"
                                    class="text-center">
                                    {{ nfse.msg_erro }}
                                </b-card>  
                            </b-card-group>                                                              
                        </b-col>
                        <b-col md="12" sm="12">
                            <hr>
                        </b-col>
                    </b-row>

                    <div class="title-nfse mt-6" >
                        <p>Dados do Prestador</p>
                    </div>

                    <b-row>
                        <b-col md="12" sm="12">
                            <b-form-group label="*Empresa" label-for="nfse-empresa_id">
                                <b-form-select 
                                    id="nfse-empresa_id"
                                    name="nfse-empresa_id"
                                    ref="nfse-empresa_id"
                                    v-focus
                                    :options="companies" v-model.trim="nfse.empresa_id" 
                                    :class="{ 'form-control is-invalid' : $v.nfse.empresa_id.$error }"
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                    </b-row>
   
                    <hr>

                    <div class="title-nfse">
                        <p>Dados do Tomador</p>
                    </div>

                    <b-row>
                        <b-col md="2" sm="12">
                            <b-form-group label="*Pessoa" label-for="nfse-fl_pessoa">
                                <b-form-select 
                                    id="nfse-fl_pessoa"
                                    name="nfse-fl_pessoa"
                                    ref="nfse-fl_pessoa"
                                    v-model.trim="nfse.fl_pessoa" :options="optTipoPessoa"
                                    :class="{ 'form-control is-invalid' : $v.nfse.fl_pessoa.$error }"
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>

                        <b-col md="3" sm="12">
                            <b-form-group label="CNPJ/CPF" label-for="nfse-cpf_cnpj">
                                <!--
                                :class="{ 'form-control is-invalid' : $v.nfse.cpf_cnpj.$error }"
                                -->
                                <b-form-input 
                                    type="text"
                                    id="nfse-cpf_cnpj" 
                                    name="nfse-cpf_cnpj" 
                                    ref="nfse-cpf_cnpj" 
                                    v-model.trim="nfse.cpf_cnpj" 
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))" 

                                    v-mask="cpfCnpjMask()" 
                                    >
                                </b-form-input>

                            </b-form-group>
                        </b-col>

                        <b-col md="4" sm="12">
                            <b-form-group label="*Nome" label-for="nfse-nm_tomador">
                                <b-form-input 
                                    type="text" 
                                    id="nfse-nm_tomador" 
                                    name="nfse-nm_tomador"
                                    ref="nfse-nm_tomador"
                                    v-model.trim="nfse.nm_tomador" 
                                    :class="{ 'form-control is-invalid' : $v.nfse.nm_tomador.$error }"
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))"
                                    maxlength="100">
                                </b-form-input>
                            </b-form-group>
                        </b-col>

                        <b-col md="3" sm="12">
                            <b-form-group label="Inscrição Municipal" label-for="nfse-im">
                                <b-form-input 
                                    type="text" 
                                    id="nfse-im" 
                                    name="nfse-im" 
                                    ref="nfse-im" 
                                    v-model.trim="nfse.im" 
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))"         
                                    maxlength="15" >
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="2" sm="12">
                            <b-form-group label="*CEP" label-for="nfse-cep">
                                <b-input-group class="mb-2 custom-input-group">
                                    <b-form-input 
                                        type="text"
                                        id="nfse-cep" 
                                        name="nfse-cep" 
                                        ref="nfse-cep" 
                                        v-model.trim="nfse.cep" 
                                        :class="{ 'form-control is-invalid' : $v.nfse.cep.$error }"
                                        :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                    ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                    (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))"
                                        placeholder="Informe CEP"
                                        maxlength="10" >
                                    </b-form-input>
                                    <!-- v-mask="'##.###-###'" -->
                                    <b-input-group-append>
                                        <b-button size="sm" text="Button" variant="secondary" class="custom-search-button" 
                                            @click="buscarCep"
                                            :disabled= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                    ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                    (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))">
                                            <i class="fa fa-search"></i>
                                        </b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                        </b-col>

                        <b-col md="5" sm="12">
                            <b-form-group label="*Endereço" label-for="nfse-endereco">
                                <b-form-input 
                                    type="text"
                                    id="nfse-endereco" 
                                    name="nfse-endereco" 
                                    ref="nfse-endereco" 
                                    v-model.trim="nfse.endereco" 
                                    :class="{ 'form-control is-invalid' : $v.nfse.endereco.$error }"
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))"   
                                    maxlength="100">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group label="*Número" label-for="nfse-numero">
                                <b-form-input 
                                    type="text"
                                    id="nfse-numero" 
                                    name="nfse-numero" 
                                    ref="nfse-numero" 
                                    v-model.trim="nfse.numero" 
                                    :class="{ 'form-control is-invalid' : $v.nfse.numero.$error }"
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))"
                                    maxlength="10">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="*Bairro" label-for="nfse-bairro">
                                <b-form-input 
                                    type="text"
                                    id="nfse-bairro" 
                                    name="nfse-bairro" 
                                    ref="nfse-bairro" 
                                    v-model.trim="nfse.bairro" 
                                    :class="{ 'form-control is-invalid' : $v.nfse.bairro.$error }"
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))"
                                    maxlength="30">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="4" sm="12">
                            <b-form-group label="Complemento" label-for="nfse-complemento">
                                <b-form-input 
                                    type="text"
                                    id="nfse-complemento" 
                                    name="nfse-complemento" 
                                    ref="nfse-complemento" 
                                    v-model.trim="nfse.complemento" 
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))"
                                    maxlength="70">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="8" sm="12">
                            <b-form-group label="Município/UF" label-for="nfse-municipio_id">
                                <b-form-select 
                                    id="nfse-municipio_id"
                                    name="nfse-municipio_id"
                                    ref="nfse-municipio_id"
                                    :options="citiesCache" v-model.trim="nfse.municipio_id" 
                                    :class="{ 'form-control is-invalid' : $v.nfse.municipio_id.$error }"
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="8" sm="12">
                            <b-form-group label="E-mail" label-for="nfse-email">
                                <b-form-input 
                                    type="text"
                                    id="nfse-email" 
                                    name="nfse-email" 
                                    ref="nfse-email" 
                                    v-model.trim="nfse.email" 
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))"                            
                                    maxlength="50">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="4" sm="12">
                            <b-form-group label="Telefone" label-for="nfse-telefone">
                                <b-form-input 
                                    type="text"
                                    id="nfse-telefone" 
                                    name="nfse-telefone" 
                                    ref="nfse-telefone" 
                                    v-model.trim="nfse.telefone" 
                                    v-mask="'(##) #########'"
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <hr>
                    <div class="title-nfse">
                        <p>Dados do Serviço</p>
                    </div>

                    <b-row>
                        <b-col md="12" sm="12">
                            <b-form-group label="*Atividade / CNAE" label-for="nfse-cnae_id">
                                <b-form-select 
                                    id="nfse-cnae_id"
                                    name="nfse-cnae_id"
                                    ref="nfse-cnae_id"
                                    v-model.trim="nfse.cnae_id" 
                                    :options="cnaesCache"
                                    :class="{ 'form-control is-invalid' : $v.nfse.cnae_id.$error }"
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="3" sm="12">
                            <b-form-group label="*Cofins" label-for="nfse-vlr_cofins">
                                 <input 
                                    type="text" 
                                    id="nfse-vlr_cofins" 
                                    name="nfse-vlr_cofins" 
                                    ref="nfse-vlr_cofins" 
                                    style="text-align: right;"
                                    class="form-control" 
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))"
                                    v-model.lazy="nfse.vlr_cofins"
                                    v-money="money" /> 
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="*CSLL" label-for="nfse-vlr_csll">
                                 <input 
                                    type="text" 
                                    id="nfse-vlr_csll" 
                                    name="nfse-vlr_csll" 
                                    ref="nfse-vlr_csll" 
                                    style="text-align: right;"
                                    class="form-control" 
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))"
                                    v-model.lazy="nfse.vlr_csll"
                                    v-money="money" /> 
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="*INSS" label-for="nfse-vlr_inss">
                                 <input 
                                    type="text" 
                                    id="nfse-vlr_inss" 
                                    name="nfse-vlr_inss" 
                                    ref="nfse-vlr_inss" 
                                    style="text-align: right;"
                                    class="form-control" 
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))"
                                    v-model.lazy="nfse.vlr_inss"
                                    v-money="money" /> 
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="*IR" label-for="nfse-vlr_ir">
                                 <input 
                                    type="text" 
                                    id="nfse-vlr_ir" 
                                    name="nfse-vlr_ir" 
                                    ref="nfse-vlr_ir" 
                                    style="text-align: right;"
                                    class="form-control" 
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))"
                                    v-model.lazy="nfse.vlr_ir"
                                    v-money="money" /> 
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="2" sm="12">
                            <b-form-group label="*PIS" label-for="nfse-vlr_pis">
                                 <input 
                                    type="text" 
                                    id="nfse-vlr_pis" 
                                    name="nfse-vlr_pis" 
                                    ref="nfse-vlr_pis" 
                                    style="text-align: right;"
                                    class="form-control" 
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))"
                                    v-model.lazy="nfse.vlr_pis"
                                    v-money="money" /> 
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group label="*ISS" label-for="nfse-vlr_iss">
                                 <input 
                                    type="text" 
                                    id="nfse-vlr_iss" 
                                    name="nfse-vlr_iss" 
                                    ref="nfse-vlr_iss" 
                                    style="text-align: right;"
                                    class="form-control" 
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))"
                                    v-model.lazy="nfse.vlr_iss"
                                    v-money="money" /> 
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="*ISS Retido Fonte" label-for="nfse-fl_iss_retido">
                                <b-form-select 
                                    id="nfse-fl_iss_retido"
                                    name="nfse-fl_iss_retido"
                                    ref="nfse-fl_iss_retido"
                                    v-model.trim="nfse.fl_iss_retido" :options="optSimNao"
                                    :class="{ 'form-control is-invalid' : $v.nfse.fl_iss_retido.$error }"
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                        <b-col md="5" sm="12">
                            <b-form-group label="*Alíquota aplicável (Simples Nacional ou ISS)" label-for="nfse-aliquota_iss">
                                 <input 
                                    type="text" 
                                    id="nfse-aliquota_iss" 
                                    name="nfse-aliquota_iss" 
                                    ref="nfse-aliquota_iss" 
                                    style="text-align: right;"
                                    class="form-control" 
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))"
                                    v-model.lazy="nfse.aliquota_iss"
                                    v-money="money" /> 
                            </b-form-group>
                        </b-col>                        
                    </b-row>

                    <b-row>
                        <b-col md="7" sm="12">
                            <b-form-group label="Item da Lista de Serviço (LC116)" label-for="nfse-lista_servico_id">
                                <b-form-select 
                                    id="nfse-lista_servico_id"
                                    name="nfse-lista_servico_id"
                                    ref="nfse-lista_servico_id"
                                    v-model.trim="nfse.lista_servico_id" :options="servicesCache"
                                    :class="{ 'form-control is-invalid' : $v.nfse.lista_servico_id.$error }"
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                        <b-col md="5" sm="12">
                            <b-form-group label="*Cód. de Tributação (Nacional ou Municipal)" label-for="nfse-cod_servico_municipio">
                                <b-form-input 
                                    type="text"
                                    id="nfse-cod_servico_municipio" 
                                    name="nfse-cod_servico_municipio" 
                                    ref="nfse-cod_servico_municipio" 
                                    v-model.trim="nfse.cod_servico_municipio" 
                                    :class="{ 'form-control is-invalid' : $v.nfse.cod_servico_municipio.$error }"
                                    maxlength="9" 
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))">
                                </b-form-input>
                            </b-form-group>
                        </b-col>                        
                    </b-row>

                    <b-row>
                        <b-col md="12" sm="12">
                            <b-form-group label="*Descrição do Serviço" label-for="nfse-descricao">
                                <b-form-textarea
                                    type="text"
                                    id="nfse-descricao" 
                                    name="nfse-descricao" 
                                    ref="nfse-descricao" 
                                    v-model.trim="nfse.descricao" 
                                    :class="{ 'form-control is-invalid' : $v.nfse.descricao.$error }"
                                    rows="3"
                                    max-rows="3"
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))">
                                </b-form-textarea>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="2" sm="12">
                            <b-form-group label="*Competência" label-for="nfse-dt_inicial_integracao">
                                <b-form-input 
                                    type="text"
                                    id="nfse-dt_competencia" 
                                    name="nfse-dt_competencia" 
                                    ref="nfse-dt_competencia"
                                    v-model.trim="nfse.dt_competencia" 
                                    :class="{ 'form-control is-invalid' : $v.nfse.dt_competencia.$error }"
                                    v-mask="'##/##/####'"
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group label="*Valor da Nota" label-for="nfse-vlr_total">
                                 <input 
                                    type="text" 
                                    id="nfse-vlr_total" 
                                    name="nfse-vlr_total" 
                                    ref="nfse-vlr_total" 
                                    style="text-align: right;"
                                    class="form-control" 
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))"
                                    v-model.lazy="nfse.vlr_total"
                                    v-money="money" /> 
                            </b-form-group>
                        </b-col>                           
                        <b-col md="2" sm="12">
                            <b-form-group label="*Enviar no E-mail?" label-for="nfse-fl_envia_email">
                                <b-form-select 
                                    id="nfse-fl_envia_email"
                                    name="nfse-fl_envia_email"
                                    ref="nfse-fl_envia_email"
                                    v-model.trim="nfse.fl_envia_email" :options="optSimNao"
                                    :class="{ 'form-control is-invalid' : $v.nfse.fl_envia_email.$error }"
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                        <b-col md="5" sm="12">
                            <b-form-group label="E-mails para receber a NFS-e" label-for="nfse-email_envio">
                                <b-form-input 
                                    type="text"
                                    id="nfse-email_envio" 
                                    name="nfse-email_envio" 
                                    ref="nfse-email_envio" 
                                    v-model.trim="nfse.email_envio" 
                                    maxlength="100" 
                                    :readonly= "(((!isInsert) && (!this.$store.state.user.nfse_edi)) || 
                                                  ((nfse.fl_situacao === '4') || (nfse.fl_situacao === '5') || (nfse.fl_situacao === 'C') || 
                                                   (nfse.fl_situacao === 'P') || (nfse.fl_situacao === 'X')))">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <!-- Somente cria o campo Integração desabilitado na alteração se realmente o campo esta preenchido, caso contrario eh manual! -->
                    <b-row v-if="nfse.integracao_id > 0">
                        <b-col md="12" sm="12">
                            <b-form-group label="Integração" label-for="nfse-integracao_id">
                                <b-form-select 
                                    id="nfse-integracao_id"
                                    name="nfse-integracao_id"
                                    ref="nfse-integracao_id"
                                    :options="integrations" v-model.trim="nfse.integracao_id" 
                                    value-field="item"
                                    text-field="name"
                                    readonly
                                    disabled>
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                    </b-row>
		
                    <div style="padding: 10px 0px 10px 0px; display: flex; justify-content: end;"> 
                        <b-button class="mr-2" style="width: 150px;"
                            @click="toggleModal">Cancelar
                        </b-button>  
                        <b-button variant="success" id="btn-principal" class="mr-2" style="width: 150px;"  
                            v-if="((((isInsert) || (this.$store.state.user.nfse_edi)) && 
                                    ((nfse.fl_situacao === '0') || (nfse.fl_situacao === '1') || (nfse.fl_situacao === '2') || (nfse.fl_situacao === '3'))) || 
                                    ((isInsert) && (typeof(nfse.fl_situacao === 'undefined'))))" 
                            @click="saveNfse">Salvar 
                        </b-button>
                        <b-button id="btn-transmitir" variant="info" class="mr-2" style="width: 260px;" 
                            v-if="(((!isInsert) && (this.$store.state.user.nfse_edi) ) && 
                                    ((nfse.fl_situacao === '0') || (nfse.fl_situacao === '1') || (nfse.fl_situacao === '2') || (nfse.fl_situacao === '3')))" 
                            :disabled="btnTransmitirClicado"                                                                
                            @click="transmitNfse">Agendar Processamento
                        </b-button>
                    </div>
                </b-form>        
            </b-card>
        </div>

    </div>  
</template>

<script>
import { baseApiUrl, baseS3Url, showError } from '@/global'
import { mapState } from 'vuex'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
import Modal  from '../template/Modal'
import { required, minLength } from "vuelidate/lib/validators";
import formMixin from '../../config/mixinform';
import {VMoney} from 'v-money'

// Cache
import citiesJson from '../../cache-data/municipios.json'
import cnaesJson from '../../cache-data/cnaes.json'
import servicesJson from '../../cache-data/listaservicos.json'

export default {
    name: 'Nfses',
    computed: mapState(['user']),
    components: { PageTitle, Modal },
    mixins: [ formMixin ],

    data: function () {
        return {
            mode: 'save',
            modalActive: false,
            tituloModal: null,
            isInsert: false,
            notaAutorizada: 'N',
            btnTransmitirClicado: false,
            filtroRep: {},
            filtroExp: {},
            repNfse: {},
            filtro: {},
            nfse: {},
            nfses: [],
            companies: [],

            fields: [
                { key: 'nfse_id', label: 'ID'},
                { key: 'nm_cliente', label: 'Cliente'},
                { key: 'nm_empresa', label: 'Empresa'},
                { key: 'situacoes', label: 'Status' },  
                { key: 'actions', label: 'Ações' }
            ],
            page: 1,
            paginar: '10',
            paginarPreferencia: '',
            optPaginar: [
                        { item: '10', name: '10 itens' },
                        { item: '25', name: '25 itens' },
                        { item: '50', name: '50 itens' }
            ],            
            count: 0,
            limit: 0,

            optSimNao: [
                { value: "S", text: 'Sim' },
                { value: "N", text: 'Não' }
            ],

            optTipoPessoa: [
                { value: "F", text: 'Física' },
                { value: "J", text: 'Juridica' },
                { value: "E", text: 'Estrangeira' }
            ],

            situacaoSelecionada: 'T',            
            optSituacao: [
                { value: "T", text: 'Todas' },
                { value: "0", text: 'Pendente' },
                { value: "P", text: 'Em Autorização' },
                { value: "1", text: 'Não Recebida' },
                { value: "2", text: 'Não Processada' },
                { value: "3", text: 'Processada com Erro' },
                { value: "4", text: 'Autorizada' },
                { value: "5", text: 'Autorizada com Aviso' },
                { value: "X", text: 'Em Cancelamento' },
                { value: "C", text: 'Cancelada'}
            ], 

            mesSelecionado: '01',            
            optMes: [
                { value: "01", text: 'Janeiro' },
                { value: "02", text: 'Fevereiro' },
                { value: "03", text: 'Março' },
                { value: "04", text: 'Abril' },
                { value: "05", text: 'Maio' },
                { value: "06", text: 'Junho' },
                { value: "07", text: 'Julho' },
                { value: "08", text: 'Agosto' },
                { value: "09", text: 'Setembro' },
                { value: "10", text: 'Outubro' },
                { value: "11", text: 'Novembro' },
                { value: "12", text: 'Dezembro' }
            ], 

            anoSelecionado: '2026',            
            optAno: [
                { value: "2026", text: '2026' }
            ], 

            empSelecionada: null,            
            empRepSelecionada: null,
            cnaeRepSelecionada: null,
            empExpSelecionada: null,

            codCancelSelecionada: '4',            
            optCodigoCancel: [
                { value: "1", text: 'Erro na Emissão' },
                { value: "2", text: 'Serviço não Prestado' },
                { value: "4", text: 'Duplicidade da Nota' }
            ],
            justifCancelSelecionada: null,

            citiesCache: [],
            cnaesCache: [],
            servicesCache: [],
            clients: [],
            services: [],
            integrations: [],

            money: {
                decimal: ',',
                thousands: '.',	
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false 
            },

            getStatusItem: (situacao) => {
                let classeSituacao;
                switch (situacao) {
                    case '0':
                        classeSituacao = "primary";
                        break;
                    case '1':
                    case '2':
                    case '3':
                        classeSituacao = "danger";
                        break;
                    case '4':
                        classeSituacao = "success";
                        break;
                    case '5':
                        classeSituacao = "info";
                        break;
                    case 'P':
                    case 'X':
                        classeSituacao = "secondary";
                        break;
                    case 'C':
                        classeSituacao = "warning";
                        break;
                    default:
                        classeSituacao = "secondary";
                }
                return classeSituacao;
            }
        }
    },

    validations: {
        nfse: {
            empresa_id: { required },
            fl_pessoa: { required },
            nm_tomador: { required },
            /// cpf_cnpj: { required },  Retirei temporariamente em 02/08/24 depois fazer validacao geral para ESTRANGEIRO QUE PERMITE EM BRANCO!
            cep: { required, minLength: minLength(8) },
            endereco: { required },
            numero: { required },
            bairro: { required },
            municipio_id: { required },
            ///telefone: { required, minLength: minLength(13) },
            ///email: { required, email },
            cnae_id: { required },
            fl_iss_retido: { required },
            lista_servico_id: { required },
            cod_servico_municipio: { required },
            ///desc_servico_municipio: { required },
            dt_competencia: { required },
            descricao: { required },
            fl_envia_email: { required }
        }
    },

    directives: {money: VMoney},

    methods: {
        loadNfses() {
            var psituacao     = this.situacaoSelecionada;
            var pdt_inicial   = document.getElementById('filtro-dt_inicial').value;
            var pdt_final     = document.getElementById('filtro-dt_final').value;
            var pnumero       = document.getElementById('filtro-numero').value;
            var pvalor        = document.getElementById('filtro-valor').value;
            var pcnpj_cpf     = document.getElementById('filtro-cnpj_cpf').value;
            var pnome_cliente = document.getElementById('filtro-nome_cliente').value;
            var pemail        = document.getElementById('filtro-email').value;
            var pid_externo   = document.getElementById('filtro-id_externo').value;
            var pid_interno   = document.getElementById('filtro-id_interno').value;

            var pid_emp = this.empSelecionada;
            const pid_emps = pid_emp !== null ? pid_emp : this.$store.state.user.empsuser;

            // Parametros para filtros aplicados pelo usuario
            const config = {
                headers: {
                    situacao: psituacao,
                    dt_inicial: pdt_inicial,
                    dt_final: pdt_final,
                    numero: pnumero,
                    valor: pvalor,
                    cnpj_cpf: pcnpj_cpf,
                    nome_cliente: pnome_cliente,
                    email: pemail,
                    id_externo: pid_externo,
                    id_interno: pid_interno
                }
            };           

            const url = `${baseApiUrl}/nfse/empsusuario/${pid_emps}/pagina/${this.page}/paginar/${this.paginar}`

            axios.get(url, config)
                .then(resp => {
                    this.nfses = resp.data.data.map(item => {
                        const parts = item.nm_empresa.split(" - ", 2);
                        if (parts.length === 2) {
                            const [cnpj_empresa, nm_empresa] = parts;
                            return {...item, cnpj_empresa, nm_empresa };
                        } else {
                            return item;
                        }
                    });
                    this.count = parseInt(resp.data.count)
                    this.limit = parseInt(resp.data.limit)
            })
        },

        loadCompanies() {
            axios.get(`${baseApiUrl}/usuario/empresas/` + this.$store.state.user.userid)  
                .then(resp => {
                    if(resp.data.data){
                        this.companies = resp.data.data.map(campany => {
                            return { value: campany.empresa_id, text: campany.nm_empresa }
                        })
                    }
            })
        },

        loadClienties() {
            axios.get(`${baseApiUrl}/empresa/clientes/empsusuario/${this.$store.state.user.empsuser}`)  
                .then(resp => {
                if(resp.data.data){
                    this.clients = resp.data.data.map(client => {
                        return { item: client.item, name: client.name }
                    })
                }
            })
        },

        loadProducties() {
            axios.get(`${baseApiUrl}/empresa/produtos/empsusuario/${this.$store.state.user.empsuser}`)  
                .then(resp => {
                    if(resp.data.data){                        
                        this.services = resp.data.data.map(service => {
                            return { item: service.item, name: service.name }
                        })
                    }
            })
        },

        loadIntegrationsCompany() {
            axios.get(`${baseApiUrl}/empresa/integracao/empsusuario/${this.$store.state.user.empsuser}`)  
                .then(resp => {
                    this.integrations = resp.data.data.map(integration => {
                        return { item: integration.item, name: integration.name }
                    })
            })
        },

        // Cache local
        loadCitiesCache() {
            let cities = citiesJson.map(city => {
                return { value: city.municipio_id, text: city.nm_municipio }
            })
            this.citiesCache = cities
        },

        loadCnaesCache() {
            let cnaes = cnaesJson.map(cnae => {
                return { value: cnae.cnae_id, text: cnae.nm_cnae }
            })
            this.cnaesCache = cnaes
        },

        loadServicesCache() {
            let services = servicesJson.map(service => {
                return { value: service.lista_servico_id, text: service.nm_servico }
            })
            this.servicesCache = services
        },

        cpfCnpjMask() {
            if (this.nfse.fl_pessoa === 'F') {
                return '###.###.###-##'; // Máscara de CPF
            } else if (this.nfse.fl_pessoa === 'J') {
                return '##.###.###/####-##'; // Máscara de CNPJ
            } else if (this.nfse.fl_pessoa === 'E') {
                return ''; // Máscara para Estrangeiro
            }
        },

        formatacpfCnpj() {
            const inputValue = this.nfse.cpf_cnpj.replace(/\D/g, ''); // Remover não dígitos
           
            if (this.nfse.fl_pessoa === 'F') {
                const formattedValue = inputValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4'); // Aplicar máscara para CPF
                this.nfse.cpf_cnpj = formattedValue;
            } else if (this.nfse.fl_pessoa === 'J') {
                const formattedValue = inputValue.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5'); // Aplicar máscara para CNPJ
                this.nfse.cpf_cnpj = formattedValue;
            } else if (this.nfse.fl_pessoa === 'E') {
                this.nfse.cpf_cnpj = inputValue;
            }
        },

        loadNfse(nfse, mode = 'save') {
            this.mode = mode
            this.nfse = { ...nfse } 
            this.notaAutorizada = this.nfse.status == 'Autorizada' ? 'S' : 'N'

            axios.get(`${baseApiUrl}/nfse/nfse/${nfse.nfse_id}`)
                 .then(resp => {
                     this.nfse = resp.data.data
            })

            this.tituloModal = 'Editar NFS-e'
            this.toggleModal()
            this.formatacpfCnpj();
        },

        addNfse() {
            this.company = {}
            this.tituloModal = 'Adicionar NFS-e'
            this.toggleModal()
            this.isInsert = true;
        },

        toggleModal() {
            this.modalActive = !this.modalActive;
            if (this.modalActive === false) {
                this.reset()
            }
            this.$v.$reset();                    
		},

        togglePesquisa() {
            this.$refs.modalPesquisa.show();
		},

        limparFiltros() {
            this.situacaoSelecionada = 'T';
            document.getElementById('filtro-dt_inicial').value = "";
            document.getElementById('filtro-dt_final').value = "";
            document.getElementById('filtro-numero').value = "";
            document.getElementById('filtro-valor').value = "0,00";
            document.getElementById('filtro-cnpj_cpf').value = "";
            document.getElementById('filtro-nome_cliente').value = "";
            document.getElementById('filtro-email').value = "";
            document.getElementById('filtro-id_externo').value = "";
            document.getElementById('filtro-id_interno').value = "";
            this.empSelecionada = null;

            this.$refs.modalPesquisa.hide();
           
            this.page = 1;
            this.reset();
        },

        pesquisarNotas() { 
            // Refresh 
            this.page = 1;
            this.loadNfses()
            this.$refs.modalPesquisa.hide();
        },

        loadReports() {
            // Valida preencher os campos obrigatorios
            var pid_emp = document.getElementById('empRepSelecionada').value;
            if (pid_emp == "") {
                this.$toasted.global.defaultError({ msg: 'Por favor, informar a empresa'})
                document.getElementById('empRepSelecionada').focus()
                return
            }
            var pdt_inicial = document.getElementById('filtro-rep-dt_inicial').value;
            if (pdt_inicial == "") {
                this.$toasted.global.defaultError({ msg: 'Por favor, informar a competência inicial'})
                document.getElementById('filtro-rep-dt_inicial').focus()
                return
            }
            var pdt_final = document.getElementById('filtro-rep-dt_final').value;
            if (pdt_final == "") {
                this.$toasted.global.defaultError({ msg: 'Por favor, informar a competência final'})
                document.getElementById('filtro-rep-dt_final').focus()
                return
            }

            var pcnae = document.getElementById('cnaeRepSelecionada').value;

            // Parametros para filtros aplicados pelo usuario
            const config = {
                headers: {
                    dt_inicial: pdt_inicial,
                    dt_final: pdt_final,
                    cnae: pcnae
                }
            };          
            const url = `${baseApiUrl}/nfse/relatorio/empsusuario/${pid_emp}`

            axios.get(url, config)
                    .then(resp => {
                        this.repNfse = resp.data; 
                        if (resp.data.status) {
                            if (this.repNfse.link !== '') {
                                this.downloadReport(this.repNfse);
                            } else {
                                this.$toasted.global.defaultWarning({ msg: 'Arquivo de relatório não disponível, tente novamente!'})
                            }                            
                        } else 
                        {
                            this.$toasted.global.defaultWarning({ msg: 'Arquivo de relatório não disponível, tente novamente!'})
                        }
                    })               
                .catch(showError)
        },

        toggleRelatorio() {
            this.$refs.modalRelatorio.show();
		},

        limparFiltrosRelatorio() {
            document.getElementById('filtro-rep-dt_inicial').value = "";
            document.getElementById('filtro-rep-dt_final').value = "";
            this.empRepSelecionada = null;
            this.cnaeRepSelecionada = null;
            this.repNfse = {};
            this.$refs.modalRelatorio.hide();
        },

        gerarRelatorio() { 
            this.loadReports();
        },    
        
        loadExports() {
            // Valida preencher os campos obrigatorios
            var pid_emp = document.getElementById('empExpSelecionada').value;
            if (pid_emp == "") {
                this.$toasted.global.defaultError({ msg: 'Favor informar a empresa'})
                document.getElementById('empExpSelecionada').focus()
                return
            }
            var pmes = document.getElementById('mesSelecionado').value;
            if (pmes == "") {
                this.$toasted.global.defaultError({ msg: 'Favor informar o mês'})
                document.getElementById('mesSelecionado').focus()
                return
            }
            var pano = document.getElementById('anoSelecionado').value;
            if (pano == "") {
                this.$toasted.global.defaultError({ msg: 'Favor informar o ano'})
                document.getElementById('anoSelecionado').focus()
                return
            }
            var pemail = document.getElementById('filtro-exp-email').value;
            if (pemail == "") {
                this.$toasted.global.defaultError({ msg: 'Favor informar o e-mail'})
                document.getElementById('filtro-exp-email').focus()
                return
            }

            // Parametros para filtros aplicados pelo usuario
            const config = {
                headers: {
                    mes: pmes,
                    ano: pano,
                    email: pemail
                }
            };          
            const url = `${baseApiUrl}/nfse/exportacao/empsusuario/${pid_emp}`

            axios.get(url, config)
                    .then(resp => {
                        this.repNfse = resp.data; 
                        if (resp.data.status) {
                            this.$toasted.global.defaultSuccess({ msg: resp.data.mensagem });
                            if (resp.data.notifica) {
                                this.$toasted.global.defaultSuccess({ msg: 'Em breve você receberá um e-mail com o link para download!'})
                            }                        
                            this.limparFiltrosExportacao();
                        } else 
                        {
                            this.$toasted.global.defaultError({ msg: resp.data.mensagem })
                        }
                    })               
                .catch(showError)
        },

        toggleExportacao() {
            this.$refs.modalExportacao.show();
		},

        limparFiltrosExportacao() {
            document.getElementById('filtro-exp-email').value = "";
            this.empRepSelecionada = null;
            this.mesSelecionado = '01',            
            this.anoSelecionado = '2026',            
            this.repNfse = {};
            this.$refs.modalExportacao.hide();
        },        

        gerarExportacao() { 
            this.loadExports();
        },    

        togglePreferencia() {
            this.$refs.modalPreferencia.show();
		},

        hidePreferencia() {
            this.paginarPreferencia = this.paginar;
            this.$refs.modalPreferencia.hide();
        },        

        salvarPreferencia() {
            var preferencia = {
                paginar: this.paginarPreferencia
            };
            localStorage.setItem('__user_preference', JSON.stringify(preferencia));
            this.paginar = this.paginarPreferencia;
            // Refresh 
            this.page = 1;
            this.loadNfses()
            this.$refs.modalPreferencia.hide();
        },        

        carregarPreferencia() {
            this.paginar = '10';
            var preferencia = JSON.parse(localStorage.getItem('__user_preference'));
            if (preferencia !== null) {
                this.paginar = preferencia.paginar;
                this.paginarPreferencia = preferencia.paginar;
            } 
            else {
                // Salva valor default
                preferencia = {
                    paginar: this.paginar
                };
                localStorage.setItem('__user_preference', JSON.stringify(preferencia));
                this.paginarPreferencia = this.paginar;
            }
        },      

        reset() {
            this.mode = 'save'
            this.notaAutorizada = 'N'
            this.btnTransmitirClicado = false;    
            this.isInsert = false;
            this.justifCancelSelecionada = null;
            this.nfse = {}
            this.loadNfses()
        },

        saveNfse() {
            // Campos selects que o Vue validate não esta pegando corretamente - BUG
            if (!this.nfse.empresa_id) {
                this.$toasted.global.defaultError({ msg: "Informe Empresa" })
                document.getElementsByName('nfse-empresa_id')[0].focus()
                return
            } 
            if (!this.nfse.fl_pessoa) {
                this.$toasted.global.defaultError({ msg: "Informe Pessoa" })
                document.getElementsByName('nfse-fl_pessoa')[0].focus()
                return
            } 
            if ((this.nfse.fl_pessoa === 'F') || (this.nfse.fl_pessoa === 'J')) {
                if (!this.nfse.cpf_cnpj) {
                    this.$toasted.global.defaultError({ msg: "Informe CNPJ ou CPF" })
                    document.getElementsByName('nfse-cpf_cnpj')[0].focus()
                    return
                } 
            } 
            if (!this.nfse.municipio_id) {
                this.$toasted.global.defaultError({ msg: "Informe Município/UF" })
                document.getElementsByName('nfse-municipio_id')[0].focus()
                return
            } 
            if (!this.nfse.cnae_id) {
                this.$toasted.global.defaultError({ msg: "Informe Atividade / CNAE" })
                document.getElementsByName('nfse-cnae_id')[0].focus()
                return
            } 
            if (!this.nfse.fl_iss_retido) {
                this.$toasted.global.defaultError({ msg: "Informe ISS Retido Fonte" })
                document.getElementsByName('nfse-fl_iss_retido')[0].focus()
                return
            } 
            if (!this.nfse.lista_servico_id) {
                this.$toasted.global.defaultError({ msg: "Informe Item da Lista de Serviço (LC116)" })
                document.getElementsByName('nfse-lista_servico_id')[0].focus()
                return
            } 
            if (!this.nfse.fl_envia_email) {
                this.$toasted.global.defaultError({ msg: "Informe Enviar no E-mail" })
                document.getElementsByName('nfse-fl_envia_email')[0].focus()
                return
            } 

            if (this.validate()) {
                const method = this.nfse.nfse_id ? 'put' : 'post'
                const nfse = this.nfse.nfse_id ? `/nfse/${this.nfse.nfse_id}` : ''
                const usuario = `/usuario/${this.$store.state.user.userid}`
                const url = `${baseApiUrl}/nfse/empresa${nfse}${usuario}`      

                axios[method](url, this.nfse)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)                

                this.toggleModal() 
            }
        },

        transmitNfse() {
            // Validacao dos campos do form se for inválido interrompe o envio para API
            if (this.validate()) {
                this.$refs.modalTransmit.show();
            }
        },

        hidetransmit() { 
            this.$refs.modalTransmit.hide();
        },        

        saveAndTransmitNfse() {
            this.hidetransmit();

            if (this.validate()) {
                this.btnTransmitirClicado = true;    

                const method = this.nfse.nfse_id ? 'put' : 'post'
                const nfse = this.nfse.nfse_id ? `/nfse/${this.nfse.nfse_id}` : ''
                const usuario = `/usuario/${this.$store.state.user.userid}`
                const url = `${baseApiUrl}/nfse/empresa${nfse}${usuario}`      

                axios[method](url, this.nfse)
                    .then(() => {
                        // Transmite manualmente a NFSe para prefeitura
                        axios.get(`${baseApiUrl}/nfse/emitir${nfse}`)
                             .then(resp => {
                                if (resp.data.status) {
                                    this.$toasted.global.defaultSuccess({ msg: resp.data.mensagem })
                                } else 
                                {
                                    this.$toasted.global.defaultError({ msg: resp.data.mensagem })
                                }
                                this.toggleModal() 
                             })               
                            .catch(showError)
                    })
                    .catch(showError)
            }
        },

        cancelNfse(nfse) {
            this.nfse = { ...nfse } 
            this.$refs.modalCancel.show(nfse);
        },

        hideCancel() { 
            this.$refs.modalCancel.hide();
        },

        confirmeCancel() { 
            let justcancel   = document.getElementById('justifCancelSelecionada').value;
            if (justcancel == "") {
                this.$toasted.global.defaultError({ msg: 'Favor informar a justificativa'})
                document.getElementById('justifCancelSelecionada').focus()
                return
            }

            this.hideCancel();

            let id = this.nfse.nfse_id
            let codcancel  = this.codCancelSelecionada;

            const config = {
                headers: {
                    justificativa: justcancel
                }
            }; 

            axios.put(`${baseApiUrl}/nfse/cancelamento/${id}/codcancel/${codcancel}`, config)
                 .then(resp => {
                    if (resp.data.status) {
                        this.$toasted.global.defaultSuccess({ msg: resp.data.mensagem })
                    } else 
                    {
                        this.$toasted.global.defaultError({ msg: resp.data.mensagem })
                    }
                    this.reset()
                 })
                 .catch(showError)
        },

        removeNfse(nfse) {
            this.nfse = { ...nfse } 
            this.$refs.modalRemove.show(nfse);
        },
        hideRemove() { 
            this.$refs.modalRemove.hide();
        },
        confirmeRemove() { 
            this.hideRemove();
            const id = this.nfse.nfse_id

            axios.delete(`${baseApiUrl}/nfse/${id}`)
                 .then(() => {
                     this.$toasted.global.defaultSuccess()
                     this.reset()
                 })
                 .catch(showError)
        },
       
        cloneNfse(nfse) {
            this.nfse = { ...nfse } 
            this.$refs.modalClone.show(nfse);
        },

        hideClone() { 
            this.$refs.modalClone.hide();
        },

        confirmeClone() { 
            this.hideClone();
            const id = this.nfse.nfse_id

            axios.put(`${baseApiUrl}/nfse/duplicar/${id}`)
                 .then(resp => {
                    if (resp.data.status) {
                        this.$toasted.global.defaultSuccess({ msg: resp.data.mensagem })
                    } else 
                    {
                        this.$toasted.global.defaultError({ msg: resp.data.mensagem })
                    }
                    this.reset()
                 })
                 .catch(showError)
        },

        sendEmailNfse(nfse) {
            this.nfse = { ...nfse } 
            this.$refs.modalEmail.show(nfse);
        },

        hideEmail() { 
            this.$refs.modalEmail.hide();
        },

        confirmeEmail() { 
            this.hideEmail();
            const id = this.nfse.nfse_id

            axios.put(`${baseApiUrl}/nfse/email/${id}`)
                 .then(resp => {
                    if (resp.data.status) {
                        this.$toasted.global.defaultSuccess({ msg: resp.data.mensagem })
                    } else 
                    {
                        this.$toasted.global.defaultError({ msg: resp.data.mensagem })
                    }
                    this.reset()
                 })
                 .catch(showError)
        },

        saveArquivoComo(url, arquivo) {
            const link = document.createElement('a')
            link.href = url
            link.download = arquivo
            document.body.appendChild(link)
            link.click()
            setTimeout(function() { 
                document.body.removeChild(link)
            }, 50)

            /*
            this.$toasted.global.defaultSuccess({ msg: url})
            axios.get(url, {
                headers: {                  
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "GET, POST" ,
                    "x-amz-meta-content-type": "text/xml",
                    "Content-Type": "binary/octet-stream"
                },
            }).then(resp => {  
                this.$toasted.global.defaultSuccess({ msg: 'OPA arquivo encontrado : ' + resp})
            })
            .catch(error => {          
                this.$toasted.global.defaultWarning({ msg: error})
            })
            */
        },

        downloadXmlNfse(nfse) {
            this.nfse = { ...nfse } 
            let autorizada = this.nfse.status == 'Autorizada' ? 'S': this.nfse.status == 'Cancelada' ? 'S' : 'N'
            if (autorizada == 'S') {
                let url = `${baseS3Url}/${this.nfse.cnpj}/nfse/${this.nfse.ano_mes}/${this.nfse.guid}/${this.nfse.guid}-nfse.xml`      
                let arquivo = `${this.nfse.guid}-nfse.xml`     
                this.saveArquivoComo(url, arquivo)
            } else {
                this.$toasted.global.defaultWarning({ msg: 'NFS-e ainda não autorizada! [XML não disponível]'})
            }                            
        },

        downloadPdfNfse(nfse) {
            this.nfse = { ...nfse } 
            let autorizada = this.nfse.status == 'Autorizada' ? 'S': this.nfse.status == 'Cancelada' ? 'S' : 'N'
            if (autorizada == 'S') {
                let url = `${baseS3Url}/${this.nfse.cnpj}/nfse/${this.nfse.ano_mes}/${this.nfse.guid}/${this.nfse.guid}-nfse.pdf`      
                let arquivo = `${this.nfse.guid}-nfse.pdf`     
                this.saveArquivoComo(url, arquivo)
            } else {
                this.$toasted.global.defaultWarning({ msg: 'NFS-e ainda não autorizada! [PDF não disponível]'})
            }                            
        },

        downloadReport(repNfse) {
            this.nfse = { ...repNfse } 
            let url = this.repNfse.link
            let arquivo = this.repNfse.arquivo
            this.saveArquivoComo(url, arquivo)
            this.limparFiltrosRelatorio();
        },

        onSelectedOptionChanged () {
            this.$toasted.global.defaultTest()
        },

        async openPdfBrowser(url) {
            try {
                const response = await fetch(url, {
                    method: 'GET',
                    mode: 'cors',
                });
                const blob = await response.blob();
                const pdfBlob = new Blob([blob], { type: 'application/pdf' });
                const blobUrl = URL.createObjectURL(pdfBlob);
                window.open(blobUrl, '_blank');
                setTimeout(() => URL.revokeObjectURL(blobUrl), 2000); 
            } catch (error) {
                this.$toasted.global.defaultError({ msg: 'Erro ao abrir o arquivo'})
            }
        },
       
        openPdfNfse(nfse) {
            this.nfse = { ...nfse } 
            let autorizada = this.nfse.status == 'Autorizada' ? 'S': this.nfse.status == 'Cancelada' ? 'S' : 'N'
            if (autorizada == 'S') {
                let url = `${baseS3Url}/${this.nfse.cnpj}/nfse/${this.nfse.ano_mes}/${this.nfse.guid}/${this.nfse.guid}-nfse.pdf`      
                this.openPdfBrowser(url)
            } else {
                this.$toasted.global.defaultWarning({ msg: 'NFS-e ainda não autorizada! [PDF não disponível]'})
            }                            
        },
        
        buscarCep() {
            if (this.nfse.cep) {
                document.getElementById('nfse-endereco').value = ''
                document.getElementById('nfse-numero').value = ''
                document.getElementById('nfse-bairro').value = ''
                document.getElementById('nfse-complemento').value = ''
                document.getElementById('nfse-municipio_id').value = ''
                this.nfse.endereco = null
                this.nfse.numero = null
                this.nfse.bairro = null
                this.nfse.complemento = null
                this.nfse.municipio_id = null

                axios.get(`${baseApiUrl}/endereco/cep/${this.nfse.cep}`)
                    .then(resp => {
                        if (resp.data.status) {
                            this.$toasted.global.defaultSuccess({ msg: resp.data.mensagem })
                            if (resp.data.logradouro !== '') {
                                document.getElementById('nfse-endereco').value = resp.data.logradouro
                                this.nfse.endereco = resp.data.logradouro
                            }
                            if (resp.data.bairro !== '') {
                                document.getElementById('nfse-bairro').value = resp.data.bairro
                                this.nfse.bairro = resp.data.bairro
                            }
                            if (resp.data.complemento !== '') {
                                document.getElementById('nfse-complemento').value = resp.data.complemento
                                this.nfse.complemento = resp.data.complemento
                            }
                            if (resp.data.ibge !== '') {
                                document.getElementById('nfse-municipio_id').value = resp.data.ibge
                                this.nfse.municipio_id = resp.data.ibge
                            }
                        } else 
                        {
                            this.$toasted.global.defaultWarning({ msg: resp.data.mensagem })
                        }
                    })
                    .catch(showError) 
            }
        }

    },

    watch: {
        page() {
            this.loadNfses()
        }
    },

    mounted() {
        this.carregarPreferencia()
        this.loadNfses() 
        this.loadCompanies()
        this.loadClienties()
        this.loadProducties()
        this.loadIntegrationsCompany()
        // Cache
        this.loadCitiesCache()
        this.loadCnaesCache()
        this.loadServicesCache() 
    }    
}

</script>

<style>
#app .nfse .table-responsive {
    overflow: visible
}
</style>

<style scoped>
    .title-nfse {
        flex: 1;
        display: grid;
    }

    .error {
        border: 3px solid darkred;        
    }

    p {
        font-weight: 600;
        margin-bottom: 10px;
    }

    hr {
        border: 0;
        width: 100%;
        height: 1px;
        margin-top: 15px;
        margin-bottom: 20px;
        background-image: linear-gradient(to right,
            rgba(120, 120, 120, 0),
            rgba(120, 120, 120, 0.75),
            rgba(120, 120, 120, 0));
    }

    .btn-download {
        color: 6f42c1;
        border: 3px solid darkred;        
    }

    .btn-download2 {
        display: flex;
        align-items: center;
        color: #fff;
        font-weight: 100;
        height: 100%;
        padding: 0px 10px;
    }   

    .help {
        cursor: help;
    }   

</style>